export default class Procedure {
  constructor() {
    this.id = ''
    this.title = ''
    this.order = 0
    this.price = 0.0
  }
}
